import { Proto } from "../../pojo/Proto";
import URLString = Proto.URLString;

export type State = {
    name: string;
    url: URLString;
    parent: string;
    views: any;
    component?: string;
    display?: string;
    root?: boolean;
    viewPrefName?: string;
    sort?: number;
    isDefault?: boolean;
    sticky?: boolean;
    deepRedirect?: boolean;
    isHidden?: boolean;
};

export type States = keyof typeof StateMap;

const states = {
    home: {
        name: "home",
        component: "home",
        url: "/home",
        root: true,
        parent: "appRoot", //defined in framework.js
        views: {
            "": "home",
        },
        viewPrefName: "25L_home_mode",
    },
    dash: {
        name: "dash",
        url: "/dash",
        display: "25Live",
        sort: 1,
        isDefault: true,
        parent: "home",
        views: {
            dash: "homeDash",
        },
        sticky: true,
    },
    paymentCancel: {
        name: "paymentCancel",
        url: "/payment/cancel",
        display: "Payment Cancel",
        sort: 1.3,
        parent: "home",
        views: {
            paymentCancel: "paymentCancel",
        },
    },
    paymentSuccess: {
        name: "paymentSuccess",
        url: "/payment/success/:sessionId",
        display: "Payment Success",
        sort: 1.4,
        parent: "home",
        views: {
            paymentSuccess: "paymentSuccess",
        },
        params: {
            sessionId: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
    },
    paymentPortal: {
        name: "paymentPortal",
        component: "paymentPortal",
        url: "/payment/portal/:id",
        display: "Payment Portal",
        sort: 0.01,
        parent: "appRoot",
        views: {
            "": "paymentPortal",
        },
        params: {
            id: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
    },
    bulkEdit: {
        name: "bulkEdit",
        url: "/bulk/edit/:search/:cacheId/:itemTypeId/:dateView",
        display: "Bulk Edit",
        sort: 12,
        parent: "home",
        views: {
            bulkEdit: "bulkEdit",
        },
        sticky: true,
    },
    rose: {
        name: "rose",
        url: "/event/form",
        params: {},
        display: "Event Form",
        sort: 1.1,
        parent: "home",
        views: {
            rose: "homeRose",
        },
        sticky: true,
    },
    systemSettings: {
        name: "systemSettings",
        url: "/system/settings",
        display: "System Settings",
        sort: 1.2,
        parent: "home",
        views: {
            systemSettings: "systemSettings",
        },
        sticky: true,
        deepRedirect: true,
    },
    bpeSettings: {
        name: "bpeSettings",
        url: "/bpe",
        display: "Event Save Email",
        sort: 1.22,
        parent: "systemSettings",
        views: {
            bpeSettings: "bpeSettings",
        },
        sticky: true,
        deepRedirect: true,
    },
    bpeScenarios: {
        name: "bpeScenarios",
        url: "/scenarios",
        display: "Scenario Settings",
        sort: 1.221,
        parent: "bpeSettings",
        views: {
            bpeScenarios: "bpeScenarios",
        },
        sticky: true,
        deepRedirect: true,
    },
    bpeTemplates: {
        name: "bpeTemplates",
        url: "/templates",
        display: "Template Settings",
        sort: 1.222,
        parent: "bpeSettings",
        views: {
            bpeTemplates: "bpeTemplates",
        },
        sticky: true,
        deepRedirect: true,
    },
    bpeTemplatesEmail: {
        name: "bpeTemplatesEmail",
        url: "/email",
        display: "Emails",
        sort: 1.2221,
        parent: "bpeTemplates",
        views: {
            bpeTemplatesEmail: "bpeTemplatesEmail",
        },
        sticky: true,
        deepRedirect: true,
    },
    bpeTemplatesTodo: {
        name: "bpeTemplatesTodo",
        url: "/todo",
        display: "To Dos",
        sort: 1.2222,
        parent: "bpeTemplates",
        views: {
            bpeTemplatesTodo: "bpeTemplatesTodo",
        },
        sticky: true,
        deepRedirect: true,
    },
    generalSystemSettings: {
        name: "generalSystemSettings",
        url: "/general",
        display: "General Settings",
        sort: 1.21,
        isDefault: true,
        parent: "systemSettings",
        views: {
            generalSystemSettings: "generalSystemSettings",
        },
        sticky: true,
        deepRedirect: true,
    },
    masqueradeSettings: {
        name: "masqueradeSettings",
        url: "/masquerade",
        display: "Masquerade",
        sort: 1.211,
        parent: "generalSystemSettings",
        views: {
            masqueradeSettings: "masqueradeSettings",
        },
        sticky: true,
        deepRedirect: true,
    },
    masqueradeSwitch: {
        name: "masqueradeSwitch",
        url: "/switch",
        display: "Switch Users",
        sort: 1.2111,
        parent: "masqueradeSettings",
        views: {
            masqueradeSwitch: "masqueradeSwitch",
        },
        sticky: true,
        deepRedirect: true,
    },
    masqueradeAdmin: {
        name: "masqueradeAdmin",
        url: "/admin",
        display: "Administration",
        sort: 1.2112,
        parent: "masqueradeSettings",
        views: {
            masqueradeAdmin: "masqueradeAdmin",
        },
        sticky: true,
        deepRedirect: true,
    },
    theme: {
        name: "theme",
        url: "/theme",
        display: "Configure Theme",
        sort: 1.212,
        parent: "generalSystemSettings",
        views: {
            theme: "theme",
        },
        sticky: true,
        deepRedirect: true,
    },
    gridColoring: {
        name: "gridColoring",
        url: "/gridColoring",
        display: "Grid Coloring",
        sort: 1.213,
        parent: "generalSystemSettings",
        views: {
            gridColoring: "gridColoring",
        },
        sticky: true,
        deepRedirect: true,
    },
    gridColoringMapping: {
        name: "gridColoringMapping",
        url: "/mapping",
        display: "Color Mapping",
        sort: 1.2131,
        parent: "gridColoring",
        views: {
            gridColoringMapping: "gridColoringMapping",
        },
        sticky: true,
        deepRedirect: true,
    },
    gridColoringSchemes: {
        name: "gridColoringSchemes",
        url: "/schemes",
        display: "Color Schemes",
        sort: 1.2132,
        parent: "gridColoring",
        views: {
            gridColoringSchemes: "gridColoringSchemes",
        },
        sticky: true,
        deepRedirect: true,
    },
    userActivity: {
        name: "userActivity",
        url: "/activity",
        display: "User Activity",
        sort: 1.214,
        parent: "generalSystemSettings",
        views: {
            userActivity: "userActivity",
        },
        sticky: true,
        deepRedirect: true,
    },
    lockedItems: {
        name: "lockedItems",
        url: "/locked",
        display: "Locked Items",
        sort: 1.2141,
        parent: "userActivity",
        views: {
            lockedItems: "lockedItems",
        },
        sticky: true,
        deepRedirect: true,
    },
    pendingLocations: {
        name: "pendingLocations",
        url: "/pending/locations",
        display: "Pending Locations",
        sort: 1.2142,
        parent: "userActivity",
        views: {
            pendingLocations: "pendingLocations",
        },
        sticky: true,
        deepRedirect: true,
    },
    pendingResources: {
        name: "pendingResources",
        url: "/pending/resources",
        display: "Pending Resources",
        sort: 1.2143,
        parent: "userActivity",
        views: {
            pendingResources: "pendingResources",
        },
        sticky: true,
        deepRedirect: true,
    },
    signedInUsers: {
        name: "signedInUsers",
        url: "/signedIn",
        display: "Signed-in Users",
        sort: 1.2144,
        parent: "userActivity",
        views: {
            signedInUsers: "signedInUsers",
        },
        sticky: true,
        deepRedirect: true,
    },
    emailDefaults: {
        name: "emailDefaults",
        url: "/email",
        display: "Email Defaults",
        sort: 1.215,
        parent: "generalSystemSettings",
        views: {
            emailDefaults: "emailDefaults",
        },
        sticky: true,
        deepRedirect: true,
    },
    systemDefaults: {
        name: "systemDefaults",
        url: "/system",
        display: "System Defaults",
        sort: 1.216,
        parent: "generalSystemSettings",
        views: {
            systemDefaults: "systemDefaults",
        },
        sticky: true,
        deepRedirect: true,
    },
    userDefaults: {
        name: "userDefaults",
        url: "/user",
        display: "User Defaults",
        sort: 1.217,
        parent: "generalSystemSettings",
        views: {
            userDefaults: "userDefaults",
        },
        sticky: true,
        deepRedirect: true,
    },
    dateTimeDefaults: {
        name: "dateTimeDefaults",
        url: "/dateTime",
        display: "Date & Time Defaults",
        sort: 1.218,
        parent: "generalSystemSettings",
        views: {
            dateTimeDefaults: "dateTimeDefaults",
        },
        sticky: true,
        deepRedirect: true,
    },
    roseSettings: {
        name: "roseSettings",
        url: "/event/form",
        display: "Event Form Settings",
        sort: 1.22,
        parent: "systemSettings",
        views: {
            roseSettings: "roseSettings",
        },
        sticky: true,
        deepRedirect: true,
    },

    formConfig: {
        name: "formConfig",
        url: "/config",
        display: "Config Settings",
        sort: 1.221,
        parent: "roseSettings",
        views: {
            formConfig: "formConfig",
        },
        sticky: true,
        deepRedirect: true,
    },

    formRules: {
        name: "formRules",
        url: "/rules",
        display: "Rule Settings",
        sort: 1.222,
        parent: "roseSettings",
        views: {
            formRules: "formRules",
        },
        sticky: true,
        deepRedirect: true,
    },

    actionRules: {
        name: "actionRules",
        url: "/action",
        display: "Actions",
        sort: 1.2221,
        parent: "formRules",
        views: {
            actionRules: "actionRules",
        },
        sticky: true,
        deepRedirect: true,
    },

    validationRules: {
        name: "validationRules",
        url: "/validation",
        display: "Validation",
        sort: 1.2222,
        parent: "formRules",
        views: {
            validationRules: "validationRules",
        },
        sticky: true,
        deepRedirect: true,
    },

    formDefaults: {
        name: "formDefaults",
        url: "/defaults",
        display: "Default Settings",
        sort: 1.223,
        parent: "roseSettings",
        views: {
            formDefaults: "formDefaults",
        },
        sticky: true,
        deepRedirect: true,
    },

    eventQuotas: {
        name: "eventQuotas",
        url: "/quotas",
        display: "Event Quotas",
        sort: 1.224,
        parent: "roseSettings",
        views: {
            eventQuotas: "eventQuotas",
        },
        sticky: true,
        deepRedirect: true,
    },
    embeddingConfig: {
        name: "embeddingConfig",
        url: "/embedding",
        display: "Embedding",
        sort: 1.24,
        parent: "systemSettings",
        views: {
            embeddingConfig: "embeddingConfig",
        },
        sticky: true,
    },
    blackoutManagement: {
        name: "blackoutManagement",
        url: "/blackout/management",
        display: "Blackout Management",
        sort: 1.251,
        parent: "systemSettings",
        views: {
            blackoutManagement: "blackoutManagement",
        },
        sticky: true,
    },

    documentManagement: {
        name: "documentManagement",
        url: "/documents",
        display: "Document Management",
        sort: 1.252,
        parent: "systemSettings",
        views: {
            documentManagement: "documentManagement",
        },
        sticky: true,
        deepRedirect: true,
    },

    documents: {
        name: "documents",
        url: "/manage",
        display: "Documents",
        sort: 1.2521,
        parent: "documentManagement",
        views: {
            documents: "documents",
        },
        sticky: true,
        deepRedirect: true,
    },

    documentTemplates: {
        name: "documentTemplates",
        url: "/templates",
        display: "Templates",
        sort: 1.2522,
        parent: "documentManagement",
        views: {
            documentTemplates: "documentTemplates",
        },
        sticky: true,
        deepRedirect: true,
    },

    servicePortal: {
        name: "servicePortal",
        url: "/service/portal",
        display: "Service Portal",
        sort: 1.26,
        parent: "systemSettings",
        views: {
            servicePortal: "servicePortal",
        },
        sticky: true,
    },

    masterDefinitions: {
        name: "masterDefinitions",
        url: "/master/definitions",
        display: "Master Definitions",
        sort: 1.2601,
        parent: "systemSettings",
        views: {
            masterDefinitions: "masterDefinitions",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettings: {
        name: "searchSettings",
        url: "/search",
        display: "Search Settings",
        sort: 1.27,
        parent: "systemSettings",
        views: {
            searchSettings: "searchSettings",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettingsEvents: {
        name: "searchSettingsEvents",
        url: "/events",
        display: "Events",
        sort: 1.271,
        parent: "searchSettings",
        views: {
            searchSettingsEvents: "searchSettingsEvents",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettingsLocations: {
        name: "searchSettingsLocations",
        url: "/locations",
        display: "Locations",
        sort: 1.272,
        parent: "searchSettings",
        views: {
            searchSettingsLocations: "searchSettingsLocations",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettingsResources: {
        name: "searchSettingsResources",
        url: "/resources",
        display: "Resources",
        sort: 1.273,
        parent: "searchSettings",
        views: {
            searchSettingsResources: "searchSettingsResources",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettingsOrganizations: {
        name: "searchSettingsOrganizations",
        url: "/organizations",
        display: "Organizations",
        sort: 1.274,
        parent: "searchSettings",
        views: {
            searchSettingsOrganizations: "searchSettingsOrganizations",
        },
        sticky: true,
        deepRedirect: true,
    },

    searchSettingsTasks: {
        name: "searchSettingsTasks",
        url: "/tasks",
        display: "Tasks",
        sort: 1.275,
        parent: "searchSettings",
        views: {
            searchSettingsTasks: "searchSettingsTasks",
        },
        sticky: true,
        deepRedirect: true,
    },

    customAttributes: {
        name: "customAttributes",
        url: "/custom/attributes",
        display: "Custom Attributes",
        sort: 1.2602,
        isDefault: true,
        parent: "masterDefinitions",
        views: {
            customAttributes: "customAttributes",
        },
        sticky: true,
        deepRedirect: true,
    },

    eventCustomAttributes: {
        name: "eventCustomAttributes",
        url: "/event",
        display: "Event",
        sort: 1.26021,
        isDefault: true,
        parent: "customAttributes",
        views: {
            eventCustomAttributes: "eventCustomAttributes",
        },
        sticky: true,
    },

    locationCustomAttributes: {
        name: "locationCustomAttributes",
        url: "/location",
        display: "Location",
        sort: 1.26022,
        parent: "customAttributes",
        views: {
            locationCustomAttributes: "locationCustomAttributes",
        },
        sticky: true,
    },

    resourceCustomAttributes: {
        name: "resourceCustomAttributes",
        url: "/resource",
        display: "Resource",
        sort: 1.26023,
        parent: "customAttributes",
        views: {
            resourceCustomAttributes: "resourceCustomAttributes",
        },
        sticky: true,
    },

    organizationCustomAttributes: {
        name: "organizationCustomAttributes",
        url: "/organization",
        display: "Organization",
        sort: 1.26024,
        parent: "customAttributes",
        views: {
            organizationCustomAttributes: "organizationCustomAttributes",
        },
        sticky: true,
    },

    contactCustomAttributes: {
        name: "contactCustomAttributes",
        url: "/contact",
        display: "Contact",
        sort: 1.26025,
        parent: "customAttributes",
        views: {
            contactCustomAttributes: "contactCustomAttributes",
        },
        sticky: true,
    },

    categories: {
        name: "categories",
        url: "/categories",
        display: "Categories",
        sort: 1.2603,
        parent: "masterDefinitions",
        views: {
            categories: "categories",
        },
        sticky: true,
        deepRedirect: true,
    },

    eventCategories: {
        name: "eventCategories",
        url: "/event",
        display: "Event",
        sort: 1.26031,
        isDefault: true,
        parent: "categories",
        views: {
            eventCategories: "eventCategories",
        },
        sticky: true,
    },

    locationCategories: {
        name: "locationCategories",
        url: "/location",
        display: "Location",
        sort: 1.26032,
        parent: "categories",
        views: {
            locationCategories: "locationCategories",
        },
        sticky: true,
    },

    resourceCategories: {
        name: "resourceCategories",
        url: "/resource",
        display: "Resource",
        sort: 1.26033,
        parent: "categories",
        views: {
            resourceCategories: "resourceCategories",
        },
        sticky: true,
    },

    organizationCategories: {
        name: "organizationCategories",
        url: "/organization",
        display: "Organization",
        sort: 1.26034,
        parent: "categories",
        views: {
            organizationCategories: "organizationCategories",
        },
        sticky: true,
    },

    roles: {
        name: "roles",
        url: "/roles",
        display: "Roles",
        sort: 1.2604,
        parent: "masterDefinitions",
        views: {
            roles: "roles",
        },
        sticky: true,
        deepRedirect: true,
    },

    eventRoles: {
        name: "eventRoles",
        url: "/event",
        display: "Event",
        sort: 1.26041,
        isDefault: true,
        parent: "roles",
        views: {
            eventRoles: "eventRoles",
        },
        sticky: true,
    },

    organizationRoles: {
        name: "organizationRoles",
        url: "/organization",
        display: "Organization",
        sort: 1.26042,
        parent: "roles",
        views: {
            organizationRoles: "organizationRoles",
        },
        sticky: true,
    },

    requirements: {
        name: "requirements",
        url: "/requirements",
        display: "Requirements",
        sort: 1.2605,
        parent: "masterDefinitions",
        views: {
            requirements: "requirements",
        },
        sticky: true,
        deepRedirect: true,
    },

    otherRequirements: {
        name: "otherRequirements",
        url: "/other",
        display: "Other",
        sort: 1.26051,
        isDefault: true,
        parent: "requirements",
        views: {
            otherRequirements: "otherRequirements",
        },
        sticky: true,
    },

    calendarRequirements: {
        name: "calendarRequirements",
        url: "/calendar",
        display: "Calendar",
        sort: 1.26052,
        parent: "requirements",
        views: {
            calendarRequirements: "calendarRequirements",
        },
        sticky: true,
    },

    features: {
        name: "features",
        url: "/features",
        display: "Features",
        sort: 1.2606,
        parent: "masterDefinitions",
        views: {
            features: "features",
        },
        sticky: true,
    },

    layouts: {
        name: "layouts",
        url: "/layouts",
        display: "Layouts",
        sort: 1.2607,
        parent: "masterDefinitions",
        views: {
            layouts: "layouts",
        },
        sticky: true,
    },

    partitions: {
        name: "partitions",
        url: "/partitions",
        display: "Partitions",
        sort: 1.2608,
        parent: "masterDefinitions",
        views: {
            partitions: "partitions",
        },
        sticky: true,
    },

    orgTypes: {
        name: "orgTypes",
        url: "org/types",
        display: "Org Types",
        sort: 1.2609,
        parent: "masterDefinitions",
        views: {
            orgTypes: "orgTypes",
        },
        sticky: true,
    },

    ratings: {
        name: "ratings",
        url: "/ratings",
        display: "Org Ratings",
        sort: 1.26091,
        parent: "masterDefinitions",
        views: {
            ratings: "ratings",
        },
        sticky: true,
    },
    eventTypes: {
        name: "eventTypes",
        url: "/event/types",
        display: "Event Types",
        sort: 1.260912,
        parent: "masterDefinitions",
        views: {
            eventTypes: "eventTypes",
        },
        sticky: true,
        deepRedirect: true,
    },

    eventTypeList: {
        name: "eventTypeList",
        url: "/list",
        display: "List",
        sort: 1.2609121,
        parent: "eventTypes",
        views: {
            eventTypeList: "eventTypeList",
        },
        sticky: true,
    },

    eventTypeHierarchy: {
        name: "eventTypeHierarchy",
        url: "/hierarchy/:date/:form/:itemTypeId/:mode/:type/:typeId",
        display: "Hierarchy",
        sort: 1.2609122,
        parent: "eventTypes",
        params: {
            date: {
                value: "",
                squash: true,
                dynamic: true,
            },
            form: {
                value: "form",
                squash: true,
                dynamic: false,
            },
            itemTypeId: {
                value: "",
                squash: true,
                dynamic: true,
            },
            mode: {
                value: "",
                squash: true,
                dynamic: true,
            },
            type: {
                value: "",
                squash: true,
                dynamic: true,
            },
            typeId: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        views: {
            eventTypeHierarchy: "eventTypeHierarchy",
        },
        sticky: true,
    },
    images: {
        name: "images",
        url: "/images",
        display: "Images",
        sort: 1.261,
        parent: "masterDefinitions",
        views: {
            images: "images",
        },
        sticky: true,
    },

    cabinetFolderAdvForm: {
        name: "cabinetFolderAdvForm",
        url: "/form/:itemTypeId/:mode/:type/:typeId",
        display: "Hierarchy",
        sort: 1.2609123,
        parent: "eventTypes",
        params: {
            itemTypeId: {
                value: "",
                squash: true,
                dynamic: true,
            },
            mode: {
                value: "",
                squash: true,
                dynamic: true,
            },
            type: {
                value: "",
                squash: true,
                dynamic: true,
            },
            typeId: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        views: {
            cabinetFolderAdvForm: "cabinetFolderAdvForm",
        },
        sticky: false,
        isHidden: true,
    },
    pricingSettings: {
        name: "pricingSettings",
        url: "/pricing/settings",
        display: "Pricing Settings",
        sort: 1.2801,
        parent: "systemSettings",
        views: {
            pricingSettings: "pricingSettings",
        },
        sticky: true,
        deepRedirect: true,
    },
    pricingFormulas: {
        name: "pricingFormulas",
        url: "/formulas",
        display: "Rate Schedules",
        sort: 1.2802,
        parent: "pricingSettings",
        views: {
            pricingFormulas: "pricingFormulas",
        },
        sticky: true,
        deepRedirect: true,
    },
    editPricingFormulas: {
        name: "editPricingFormulas",
        url: "/edit",
        display: "Edit Schedules",
        sort: 1.28021,
        parent: "pricingFormulas",
        views: {
            editPricingFormulas: "editPricingFormulas",
        },
        sticky: true,
    },
    createPricingFormulas: {
        name: "createPricingFormulas",
        url: "/create",
        display: "Create Schedule",
        sort: 1.28022,
        parent: "pricingFormulas",
        views: {
            createPricingFormulas: "createPricingFormulas",
        },
        sticky: true,
    },
    pricingSetups: {
        name: "pricingSetups",
        url: "/setups",
        display: "Pricing Set-Ups",
        sort: 1.2803,
        parent: "pricingSettings",
        views: {
            pricingSetups: "pricingSetups",
        },
        sticky: true,
        deepRedirect: true,
    },
    rateGroups: {
        name: "rateGroups",
        url: "/rate/groups",
        display: "Rate Groups",
        sort: 1.28031,
        parent: "pricingSetups",
        views: {
            rateGroups: "rateGroups",
        },
        sticky: true,
    },
    taxSchedules: {
        name: "taxSchedules",
        url: "/tax/schedules",
        display: "Tax Schedules",
        sort: 1.28032,
        parent: "pricingSetups",
        views: {
            taxSchedules: "taxSchedules",
        },
        sticky: true,
    },
    pricingTimes: {
        name: "pricingTimes",
        url: "/times",
        display: "Pricing Times",
        sort: 1.28033,
        parent: "pricingSetups",
        views: {
            pricingTimes: "pricingTimes",
        },
        sticky: true,
    },
    accountingFormats: {
        name: "accountingFormats",
        url: "/accounting/formats",
        display: "Account Formats",
        sort: 1.2804,
        parent: "pricingSettings",
        views: {
            accountingFormats: "accountingFormats",
        },
        sticky: true,
    },
    publisherSettings: {
        name: "publisherSettings",
        url: "/publisher/settings",
        display: "Publisher Settings",
        sort: 1.29,
        parent: "systemSettings",
        views: {
            publisherSettings: "publisherSettings",
        },
        sticky: true,
    },

    optimizerEffectiveDating: {
        name: "optimizerEffectiveDating",
        url: "/optimizer/effective/dating",
        display: "Optimizer Effective Dating",
        sort: 6.21,
        parent: "home",
        views: {
            optimizerEffectiveDating: "optimizerEffectiveDating",
        },
        sticky: true,
    },

    userSettings: {
        name: "userSettings",
        url: "/user/settings",
        params: {},
        display: "User Settings",
        sort: 1.3,
        parent: "home",
        views: {
            userSettings: "userSettings",
        },
        sticky: true,
        deepRedirect: true,
    },

    editContactInfo: {
        name: "editContactInfo",
        url: "/editContactInfo",
        display: "Edit Contact Info",
        sort: 1.31,
        parent: "userSettings",
        views: {
            editContactInfo: "editContactInfo",
        },
        sticky: true,
        isDefault: true,
    },

    changePassword: {
        name: "changePassword",
        url: "/changePassword",
        display: "Change Password",
        sort: 1.32,
        parent: "userSettings",
        views: {
            changePassword: "changePassword",
        },
        sticky: true,
    },

    dateTimePreferences: {
        name: "dateTimePreferences",
        url: "/dateTimePreferences",
        display: "Display",
        sort: 1.33,
        parent: "userSettings",
        views: {
            dateTimePreferences: "dateTimePreferences",
        },
        sticky: true,
    },

    workflowSettings: {
        name: "workflowSettings",
        url: "/workflow/settings",
        display: "Workflow Settings",
        sort: 1.29,
        parent: "systemSettings",
        views: {
            workflowSettings: "workflowSettings",
        },
        sticky: true,
    },

    masterDefinitionTags: {
        name: "masterDefinitionTags",
        url: "/tags",
        display: "System Tags",
        sort: 1.3,
        parent: "systemSettings",
        views: {
            masterDefinitionTags: "masterDefinitionTags",
        },
        sticky: true,
        deepRedirect: true,
    },

    standardSchedules: {
        name: "standardSchedules",
        url: "/standard/schedules",
        display: "Standard Schedules",
        sort: 1.4,
        parent: "systemSettings",
        views: {
            standardSchedules: "standardSchedules",
        },
        sticky: true,
        deepRedirect: true,
    },

    integrations: {
        name: "integrations",
        url: "/integrations",
        display: "Integrations",
        sort: 1.5,
        parent: "systemSettings",
        views: {
            integrations: "integrations",
        },
        sticky: true,
        deepRedirect: true,
    },

    stripeSettings: {
        name: "stripeSettings",
        url: "/stripeSettings",
        display: "Stripe Settings",
        sort: 1.51,
        parent: "integrations",
        views: {
            stripeSettings: "stripeSettings",
        },
        sticky: true,
        deepRedirect: true,
    },

    sevenPointSolutions: {
        name: "sevenPointSolutions",
        url: "/sevenPointSolutions",
        display: "7 Point Solutions Settings",
        sort: 1.52,
        parent: "integrations",
        views: {
            sevenPointSolutions: "sevenPointSolutions",
        },
        sticky: true,
        deepRedirect: true,
    },
    legacySis: {
        name: "legacySis",
        url: "/sisImportExport",
        display: "SIS Import/Export",
        sort: 1.53,
        parent: "integrations",
        views: {
            legacySis: "legacySis",
        },
        sticky: true,
        deepRedirect: true,
    },
    studentHousing: {
        name: "studentHousing",
        url: "/studentHousing",
        display: "Student Housing",
        sort: 1.6,
        parent: "systemSettings",
        views: {
            studentHousing: "studentHousing",
        },
        sticky: true,
        deepRedirect: true,
    },

    matchProfile: {
        name: "matchProfile",
        component: "matchProfile",
        url: "/match/profile/:inviteHash",
        display: "Match Profile",
        sort: 0.02,
        parent: "appRoot",
        views: {
            "": "matchProfile",
        },
        params: {
            inviteHash: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
    },

    buildings: {
        name: "buildings",
        url: "/buildings",
        display: "Buildings",
        sort: 1.262,
        parent: "masterDefinitions",
        views: {
            buildings: "buildings",
        },
        sticky: true,
        deepRedirect: true,
    },

    buildingsSettings: {
        name: "buildingsSettings",
        url: "/settings",
        display: "Settings",
        sort: 1.2621,
        parent: "buildings",
        views: {
            buildingsSettings: "buildingsSettings",
        },
        sticky: false,
    },

    buildingsBulkCreate: {
        name: "buildingsBulkCreate",
        url: "/bulkcreate",
        display: "Bulk Create",
        sort: 1.2622,
        parent: "buildings",
        views: {
            buildingsBulkCreate: "buildingsBulkCreate",
        },
        sticky: false,
    },

    list: {
        name: "list",
        url: "/list",
        display: "List",
        sort: 3,
        parent: "home",
        views: {
            list: "homeList",
        },
        sticky: true,
    },
    calendar: {
        name: "calendar",
        url: "/calendar",
        display: "Calendar",
        sort: 4,
        parent: "home",
        views: {
            calendar: "homeCalendar",
        },
        sticky: true,
    },
    availability: {
        name: "availability",
        url: "/availability",
        display: "Availability",
        sort: 5,
        parent: "home",
        views: {
            availability: "homeAvailability",
        },
        sticky: true,
    },
    search: {
        name: "search",
        url: "/search/:subject/:viz/:search",
        params: {
            viz: {
                value: "",
                squash: true,
                dynamic: true,
            },
            subject: {
                value: "",
                squash: true,
                dynamic: true,
            },
            search: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        display: "Search",
        sort: 6,
        parent: "home",
        views: {
            search: "homeSearch",
        },
        sticky: true,
    },
    grids: {
        name: "grids",
        url: "/grids",
        display: "Meeting Pattern Grids",
        sort: 6.2,
        parent: "home",
        views: {
            grids: "grids",
        },
        sticky: true,
        deepRedirect: true,
    },
    academicGrids: {
        name: "academicGrids",
        url: "/academic",
        display: "Academic Grids",
        sort: 6.21,
        parent: "grids",
        views: {
            academicGrids: "academicGrids",
        },
        sticky: true,
    },
    optimizerGrids: {
        name: "optimizerGrids",
        url: "/optimizer",
        display: "Optimizer Grids",
        sort: 6.22,
        parent: "grids",
        views: {
            optimizerGrids: "homeCoopSched",
        },
        sticky: true,
    },
    publisher: {
        name: "publisher",
        url: "/publisher",
        display: "Publisher",
        sort: 7,
        parent: "home",
        views: {
            publisher: "homePublisher",
        },
        sticky: true,
    },
    event: {
        name: "event",
        url: "/event/{itemId:-*[0-9]+}",
        display: "Event",
        sort: 8,
        parent: "home",
        views: {
            event: "homeEvent",
        },
        sticky: true,
        deepRedirect: true,
        viewPrefName: "25L_event_details_view",
    },
    eventDetails: {
        name: "eventDetails",
        url: "/details",
        display: "Details",
        sort: 1,
        isDefault: true,
        parent: "event",
        views: {
            eventDetails: "eventDetails",
        },
        sticky: true,
    },

    eventOccurrences: {
        name: "eventOccurrences",
        url: "/occurrences",
        display: "Occurrences",
        sort: 2,
        parent: "event",
        views: {
            eventOccurrences: "eventOccurrences",
        },
        sticky: true,
    },
    eventCalendar: {
        name: "eventCalendar",
        url: "/calendar",
        display: "Calendar",
        sort: 3,
        parent: "event",
        views: {
            eventCalendar: "eventCalendar",
        },
        sticky: true,
    },
    eventSchedule: {
        name: "eventSchedule",
        url: "/schedule",
        display: "Schedule",
        sort: 4,
        parent: "event",
        views: {
            eventSchedule: "eventSchedule",
        },
        sticky: true,
    },
    eventTasks: {
        name: "eventTasks",
        url: "/tasks",
        display: "Task List",
        sort: 5,
        parent: "event",
        views: {
            eventTasks: "eventTasks",
        },
        sticky: true,
    },
    eventPricing: {
        name: "eventPricing",
        url: "/pricing/:evBillId",
        display: "Pricing",
        sort: 6,
        parent: "event",
        views: {
            eventPricing: "eventPricing",
        },
        params: {
            evBillId: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        sticky: true,
    },
    eventLynx: {
        name: "eventLynx",
        url: "/lynx",
        display: "Lynx",
        sort: 6.1,
        parent: "event",
        views: {
            eventLynx: "eventLynx",
        },
        sticky: true,
    },
    eventRegistration: {
        name: "eventRegistration",
        url: "/registration",
        display: "Registration",
        sort: 6.2,
        parent: "event",
        views: {
            eventRegistration: "eventRegistration",
        },
        sticky: true,
    },
    eventAudit: {
        name: "eventAudit",
        url: "/audit",
        display: "Audit Trail",
        sort: 7,
        parent: "event",
        views: {
            eventAudit: "eventAudit",
        },
        sticky: true,
    },
    eventEmails: {
        name: "eventEmails",
        url: "/scheduled/emails",
        display: "Scheduled Emails",
        sort: 8,
        parent: "event",
        views: {
            eventEmails: "eventEmails",
        },
        sticky: true,
    },
    location: {
        name: "location",
        url: "/location/{itemId:-*[0-9]+}",
        display: "Location",
        sort: 9,
        parent: "home",
        views: {
            location: "homeLocation",
        },
        sticky: true,
        deepRedirect: true,
        viewPrefName: "25L_space_details_view",
    },
    locationDetails: {
        name: "locationDetails",
        url: "/details",
        display: "Details",
        sort: 1,
        isDefault: true,
        parent: "location",
        views: {
            locationDetails: "locationDetails",
        },
        sticky: true,
    },
    locationList: {
        name: "locationList",
        url: "/list",
        display: "List",
        sort: 2,
        parent: "location",
        views: {
            locationList: "locationList",
        },
        sticky: true,
    },
    locationAvailability: {
        name: "locationAvailability",
        url: "/availability/daily",
        display: "Availability (Daily)",
        sort: 3,
        parent: "location",
        views: {
            locationAvailability: "locationAvailability",
        },
        params: {
            startDt: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        sticky: true,
    },
    locationAvailabilityWeekly: {
        name: "locationAvailabilityWeekly",
        url: "/availability/weekly",
        display: "Availability (Weekly)",
        sort: 4,
        parent: "location",
        views: {
            locationAvailabilityWeekly: "locationAvailabilityWeekly",
        },
        sticky: true,
    },
    locationCalendar: {
        name: "locationCalendar",
        url: "/calendar",
        display: "Calendar",
        sort: 5,
        parent: "location",
        views: {
            locationCalendar: "locationCalendar",
        },
        sticky: true,
    },
    locationAudit: {
        name: "locationAudit",
        url: "/audit",
        display: "Audit Trail",
        sort: 7,
        parent: "location",
        views: {
            locationAudit: "locationAudit",
        },
        sticky: true,
    },
    resource: {
        name: "resource",
        url: "/resource/{itemId:-*[0-9]+}",
        display: "Resource",
        sort: 10,
        parent: "home",
        views: {
            resource: "homeResource",
        },
        sticky: true,
        deepRedirect: true,
        viewPrefName: "25L_resource_details_view",
    },

    resourceDetails: {
        name: "resourceDetails",
        url: "/details",
        display: "Details",
        sort: 1,
        isDefault: true,
        parent: "resource",
        views: {
            resourceDetails: "resourceDetails",
        },
        sticky: true,
    },
    resourceList: {
        name: "resourceList",
        url: "/list",
        display: "List",
        sort: 2,
        parent: "resource",
        views: {
            resourceList: "resourceList",
        },
        sticky: true,
    },
    resourceAvailability: {
        name: "resourceAvailability",
        url: "/availability/daily",
        display: "Availability (Daily)",
        sort: 3,
        parent: "resource",
        views: {
            resourceAvailability: "resourceAvailability",
        },
        sticky: true,
    },
    resourceCalendar: {
        name: "resourceCalendar",
        url: "/calendar",
        display: "Calendar",
        sort: 4,
        parent: "resource",
        views: {
            resourceCalendar: "resourceCalendar",
        },
        sticky: true,
    },
    resourceAudit: {
        name: "resourceAudit",
        url: "/audit",
        display: "Audit Trail",
        sort: 7,
        parent: "resource",
        views: {
            resourceAudit: "resourceAudit",
        },
        sticky: true,
    },
    organization: {
        name: "organization",
        url: "/organization/{itemId:-*[0-9]+}",
        display: "Organization",
        sort: 11,
        parent: "home",
        views: {
            organization: "homeOrganization",
        },
        sticky: true,
        deepRedirect: true,
        viewPrefName: "25L_org_details_view",
    },
    organizationDetails: {
        name: "organizationDetails",
        url: "/details",
        display: "Details",
        sort: 1,
        isDefault: true,
        parent: "organization",
        views: {
            organizationDetails: "organizationDetails",
        },
        sticky: true,
    },
    organizationList: {
        name: "organizationList",
        url: "/list",
        display: "List",
        sort: 2,
        parent: "organization",
        views: {
            organizationList: "organizationList",
        },
        sticky: true,
    },
    organizationCalendar: {
        name: "organizationCalendar",
        url: "/calendar",
        display: "Calendar",
        sort: 3,
        parent: "organization",
        views: {
            organizationCalendar: "organizationCalendar",
        },
        sticky: true,
    },
    organizationAudit: {
        name: "organizationAudit",
        url: "/audit",
        display: "Audit Trail",
        sort: 7,
        parent: "organization",
        views: {
            organizationAudit: "organizationAudit",
        },
        sticky: true,
    },
    contact: {
        name: "contact",
        url: "/contact/{itemId:-*[0-9]+}",
        display: "Contact",
        sort: 13,
        parent: "home",
        views: {
            contact: "homeContact",
        },
        sticky: true,
        deepRedirect: true,
        //to-do sort out pref stuff
        //viewPrefName: "25L_cont_details_view"
    },
    contactDetails: {
        name: "contactDetails",
        url: "/details",
        display: "Details",
        sort: 1,
        isDefault: true,
        parent: "contact",
        views: {
            contactDetails: "contactDetails",
        },
        sticky: true,
    },
    contactList: {
        name: "contactList",
        url: "/list",
        display: "List",
        sort: 2,
        parent: "contact",
        views: {
            contactList: "contactList",
        },
        sticky: true,
    },
    contactCalendar: {
        name: "contactCalendar",
        url: "/calendar",
        display: "Calendar",
        sort: 3,
        parent: "contact",
        views: {
            contactCalendar: "contactCalendar",
        },
        sticky: true,
    },
    contactAudit: {
        name: "contactAudit",
        url: "/audit",
        display: "Audit Trail",
        sort: 7,
        parent: "contact",
        views: {
            contactAudit: "contactAudit",
        },
        sticky: true,
    },
    report: {
        name: "report",
        url: "/report",
        display: "Reports",
        sort: 12,
        parent: "home",
        views: {
            report: "homeReport",
        },
        sticky: true,
        deepRedirect: true,
    },
    reportStarred: {
        name: "reportStarred",
        url: "/starred",
        display: "Starred Reports",
        sort: 1,
        isDefault: true,
        parent: "report",
        params: {
            report_id: {
                value: "",
                squash: true,
                dynamic: false,
            },
        },
        views: {
            reportStarred: "reportStarred",
        },
        sticky: true,
    },
    reportEvents: {
        name: "reportEvents",
        url: "/events",
        display: "Event Reports",
        sort: 2,
        parent: "report",
        views: {
            reportEvents: "reportEvents",
        },
        sticky: true,
    },
    reportLocations: {
        name: "reportLocations",
        url: "/locations",
        display: "Location Reports",
        sort: 3,
        parent: "report",
        views: {
            reportLocations: "reportLocations",
        },
        sticky: true,
    },
    reportResources: {
        name: "reportResources",
        url: "/resources",
        display: "Resource Reports",
        sort: 4,
        parent: "report",
        views: {
            reportResources: "reportResources",
        },
        sticky: true,
    },
    reportOther: {
        name: "reportOther",
        url: "/other",
        display: "Other Reports",
        sort: 5,
        parent: "report",
        views: {
            reportOther: "reportOther",
        },
        sticky: true,
    },
    formInstance: {
        name: "formInstance",
        url: "/form/instance/{itemId:-*[0-9]+}",
        display: "Form Instance",
        sort: 14,
        parent: "home",
        views: {
            formInstance: "formInstance",
        },
        sticky: true,
    },
    formItems: {
        name: "formItems",
        url: "/form/items",
        display: "Form Items",
        sort: 15,
        parent: "home",
        views: {
            formItems: "formItems",
        },
        sticky: true,
    },
    formDefinition: {
        name: "formDefinition",
        url: "/form/definition",
        display: "Form Definition",
        sort: 15,
        parent: "home",
        views: {
            formDefinition: "formDefinition",
        },
        sticky: true,
    },
    embeddingsTest: {
        name: "embeddingsTest",
        url: "/embeddings-test",
        display: "Embeddings Test",
        sort: 16,
        parent: "home",
        views: {
            embeddingsTest: "embeddingsTest",
        },
        sticky: true,
    },
    lynxHome: {
        name: "lynx",
        url: "/lynx/:lynxInst",
        display: "Lynx",
        sort: 17,
        parent: "appRoot",
        views: {
            "": "lynxHome",
        },
        params: {
            lynxInst: {
                value: "",
                squash: true,
                dynamic: true,
            },
        },
        sticky: true,
    },
} as { [key: string]: State };

export const StateMap = states;
